<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="fill" height="2" rx="1" width="24"/>
    <rect :fill="fill" height="2" rx="1" width="14" x="5" y="7"/>
    <rect :fill="fill" height="2" rx="1" width="6" x="9" y="14"/>
  </svg>
</template>

<script>

export default {
  name: 'FilterIcon', // Filter is a reserved name so added Icon to prevent the error
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
